import { FlowClient } from "@@api";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { ContextMetadataModel } from "../../../api/api";
import useApiClient from "../../../common/hooks/useApiClient";

export default function useApiContexts(): UseQueryResult<
  ContextMetadataModel[],
  Error
> {
  const flowClient = useApiClient(FlowClient);
  const contexts = useQuery({
    queryKey: ["flowContexts"],
    queryFn: () => flowClient.getContexts(),
  });
  return contexts;
}
